// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b-vehicle-compare-bar-card[data-v-207da336] {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.b-vehicle-compare-bar-card img[data-v-207da336] {
  max-height: 40px;
}
.b-vehicle-compare-bar-card__description[data-v-207da336] {
  font-size: 12px;
  line-height: 1.1rem;
  height: 30px;
}
.b-vehicle-compare-bar-card__button[data-v-207da336] {
  font-size: 12px;
  font-weight: 600;
  color: #c71818;
}
.b-vehicle-compare-bar-card__button[data-v-207da336]:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/components/leasingOffers/VehicleCompareBarCard.vue","webpack://./VehicleCompareBarCard.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;ACAF;ADEE;EACE,gBAAA;ACAJ;ADGE;EACE,eAAA;EACA,mBAAA;EACA,YAAA;ACDJ;ADIE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;ACFJ;ADGI;EACE,0BAAA;ACDN","sourcesContent":["\r\n.b-vehicle-compare-bar-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n\r\n  img {\r\n    max-height: 40px;\r\n  }\r\n\r\n  &__description {\r\n    font-size: 12px;\r\n    line-height: 1.1rem;\r\n    height: 30px;\r\n  }\r\n\r\n  &__button {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: #c71818;\r\n    &:hover {\r\n      text-decoration: underline;\r\n    }\r\n  }\r\n}\r\n",".b-vehicle-compare-bar-card {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n.b-vehicle-compare-bar-card img {\n  max-height: 40px;\n}\n.b-vehicle-compare-bar-card__description {\n  font-size: 12px;\n  line-height: 1.1rem;\n  height: 30px;\n}\n.b-vehicle-compare-bar-card__button {\n  font-size: 12px;\n  font-weight: 600;\n  color: #c71818;\n}\n.b-vehicle-compare-bar-card__button:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
